<kl-detail-filter
  (onSaveFilter)="commitSave($event)"
  (onSelectFilter)="selectFilter($event)"
  (onCommitFilter)="commitFilter()"
  (onCloseFilter)="closeFilter()"
  (onClearAll)="clearAll()"
  (onCloseAlert)="alertShow = false"
  (onDeleteFromValues)="deleteFromValues($event)"
  (onDeleteSavedFilter)="deleteSavedFilter($event)"
  [filterList]="filterList"
  [saveForm]="saveForm"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [showSavedFilters]="showSavedFilters"
  [showBottomButtons]="showBottomButtons"
  [currentFilter]="currentFilter"
  [selectedFilterValues]="selectedFilterValues"
>
  <form #filterForm="ngForm">
    <div class="filter-group" #status>
      <div
        class="filter-group-heading ui-clickable"
        (click)="status.collapsed = !status.collapsed"
      >
        <p class="font-weight-light">
          {{ "status" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': status.collapsed,
              'fa-angle-down': !status.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!status.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          #statusDropdown
          [options]="statusOptions"
          name="status"
          [(ngModel)]="statusValue"
          [style]="{ width: '90%' }"
        >
        </p-dropdown>
      </div>
    </div>
    <div class="filter-group" #code>
      <div
        class="filter-group-heading ui-clickable"
        (click)="code.collapsed = !code.collapsed"
      >
        <p class="font-weight-light">
          {{ "code" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': code.collapsed,
              'fa-angle-down': !code.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!code.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="code"
          #codeDropdown
          [(ngModel)]="codeExpressionValue"
          [options]="expressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="input-group" style="width: 90%">
          <input
            type="text"
            [(ngModel)]="codeValue"
            #codeInput
            name="code_input"
            class="form-control form-control-sm"
            maxlength="20"
          />
          <div class="input-group-append">
            <span
              class="input-group-text transparent"
              (click)="
                setModal(
                  'material',
                  'MATERIAL_CODE',
                  CustomerComponent,
                  false,
                  '01.02.01'
                )
              "
            >
              <i class="fal fa-ellipsis-h"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #description>
      <div
        class="filter-group-heading ui-clickable"
        (click)="description.collapsed = !description.collapsed"
      >
        <p class="font-weight-light">
          {{ "description" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': description.collapsed,
              'fa-angle-down': !description.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!description.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="description"
          #descriptionDropdown
          [(ngModel)]="descriptionExpressionValue"
          [options]="expressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        ></p-dropdown>
        <div class="input-group" style="width: 90%">
          <input
            type="text"
            [(ngModel)]="descriptionValue"
            #descriptionInput
            name="description_input"
            class="form-control form-control-sm"
            maxlength="20"
          />
          <div class="input-group-append">
            <span
              class="input-group-text transparent"
              (click)="
                setModal(
                  'material',
                  'MATERIAL_DESCRIPTION',
                  CustomerComponent,
                  false,
                  '01.02.01'
                )
              "
            >
              <i class="fal fa-ellipsis-h"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #identityNum>
      <div
        class="filter-group-heading ui-clickable"
        (click)="identityNum.collapsed = !identityNum.collapsed"
      >
        <p class="font-weight-light">
          {{ "identity_num" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': identityNum.collapsed,
              'fa-angle-down': !identityNum.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!identityNum.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="identityNum"
          #identityNumDropdown
          [(ngModel)]="identityNumExpressionValue"
          [options]="expressionOptions"
          autoWidth="false"
          [style]="{ width: '90%' }"
        >
        </p-dropdown>
        <input
          [(ngModel)]="identityNumValue"
          #identityNumInput
          style="width: 90%"
          name="identityNum_input"
          class="form-control form-control-sm"
          maxlength="20"
        />
      </div>
    </div>

    <div class="filter-group" #user>
      <div
        class="filter-group-heading ui-clickable"
        (click)="user.collapsed = !user.collapsed"
      >
        <p class="font-weight-light">
          {{ "recording_user" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': user.collapsed,
              'fa-angle-down': !user.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!user.collapsed">
        <div class="form-group my-1">
          <p-dropdown
            [emptyFilterMessage]="'not_found' | translate"
            [style]="{ width: '250px' }"
            [options]="userOptions"
            [optionLabel]="'username'"
            [filter]="true"
            name="create_user"
            [(ngModel)]="userValue"
            [placeholder]="'unselected' | translate"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="filter-group" #materialRecordDate>
      <div
        class="filter-group-heading ui-clickable"
        (click)="materialRecordDate.collapsed = !materialRecordDate.collapsed"
      >
        <p class="font-weight-light">
          {{ "record_date" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': materialRecordDate.collapsed,
              'fa-angle-down': !materialRecordDate.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!materialRecordDate.collapsed"
      >
        <div class="form-group my-1">
          <label for="first_date">
            <span class="font-weight-light">{{
              "first_date" | translate
            }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="first_tate"
              id="first_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="firstDate"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
        <div class="form-group my-1">
          <label for="last_date">
            <span class="font-weight-light">{{ "last_date" | translate }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="last_date"
              id="last_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="lastDate"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #lastChangedUser>
      <div
        class="filter-group-heading ui-clickable"
        (click)="lastChangedUser.collapsed = !lastChangedUser.collapsed"
      >
        <p class="font-weight-light">
          {{ "last_changed_user" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': lastChangedUser.collapsed,
              'fa-angle-down': !lastChangedUser.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!lastChangedUser.collapsed">
        <div class="form-group my-1">
          <p-dropdown
            [emptyFilterMessage]="'not_found' | translate"
            [options]="userOptions"
            [optionLabel]="'username'"
            [filter]="true"
            name="change_user"
            [(ngModel)]="lastChangedUserValue"
            [style]="{ width: '90%' }"
            [placeholder]="'unselected' | translate"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="filter-group" #lastChangedDate>
      <div
        class="filter-group-heading ui-clickable"
        (click)="lastChangedDate.collapsed = !lastChangedDate.collapsed"
      >
        <p class="font-weight-light">
          {{ "last_date_changed" | translate }}
          <i
            class="fa"
            [ngClass]="{
              'fa-angle-up': lastChangedDate.collapsed,
              'fa-angle-down': !lastChangedDate.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!lastChangedDate.collapsed">
        <div class="form-group my-1">
          <label for="last_changed_first_date">
            <span class="font-weight-light">{{
              "first_date" | translate
            }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="last_changed_first_date"
              id="last_changed_first_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="firstDateLastChanged"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
        <div class="form-group my-1">
          <label for="last_changed_last_date">
            <span class="font-weight-light">{{ "last_date" | translate }}</span>
          </label>
          <div class="input-group" style="width: 90%">
            <p-calendar
              name="last_changed_last_date"
              id="last_changed_last_date"
              [locale]="locale"
              [dateFormat]="dateFormatString"
              [(ngModel)]="lastDateLastChanged"
              [showIcon]="true"
              styleClass="dateInput"
              [style]="{ width: '90%' }"
            >
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
  </form>
</kl-detail-filter>
